import {Injectable} from '@angular/core';
import {DatabaseService} from './database.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(
    private databaseService: DatabaseService,
  ) {
  }

  async clearClientData() {
    this.clearStorage();
    this.clearCookies();
    await this.databaseService.clearAll();
  }

  private clearStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  private clearCookies() {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }
}
